import { computed, Directive, effect, HostBinding, HostListener, input, output, signal } from '@angular/core';

@Directive({
  selector: '[appDragDrop]',
  exportAs: 'dragDrop',
  standalone: true,
})
export class DragDropDirective {
  filesDropped = output<File[]>();

  isDragging = signal(false);
  justDropped = signal(false);
  fileReaderSupported = signal(typeof (window.FileReader) !== 'undefined');

  defaultText = input<string>('Sftp.Upload.Upload.DragAndDrop');
  successText = input<string>('Sftp.Upload.Upload.Dropped');
  errorText = input<string>('Sftp.Upload.Upload.FileError');

  dropZoneText = computed(() => {
    if (!this.fileReaderSupported()) return this.errorText();
    if (this.justDropped()) return this.successText();
    return this.defaultText();
  });

  @HostBinding('class.hover')
  get hoverClass() {
    return this.isDragging() && this.fileReaderSupported();
  }

  @HostBinding('class.success')
  get successClass() {
    return this.justDropped() && this.fileReaderSupported();
  }

  @HostBinding('class.error')
  get errorClass() {
    return !this.fileReaderSupported();
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    if (!this.fileReaderSupported()) return;

    event.preventDefault();
    event.stopPropagation();
    this.isDragging.set(true);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    if (!this.fileReaderSupported()) return;

    event.preventDefault();
    event.stopPropagation();
    this.isDragging.set(false);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    if (!this.fileReaderSupported()) return;

    event.preventDefault();
    event.stopPropagation();
    this.isDragging.set(false);
    this.justDropped.set(true);

    if (event.dataTransfer?.files?.length) {
      const files = Array.from(event.dataTransfer.files);
      this.filesDropped.emit(files);
    }
  }

  constructor() {
    effect(() => {
      if (this.justDropped()) {
        setTimeout(() => this.justDropped.set(false), 1500);
      }
    });
  }
}
